import Tables from "../__utils/Tables";

const $ = jQuery.noConflict();

class Tabs {
    constructor() {
        this.tabs = $('.block-tabs');
        this.tabsLinks = this.tabs.find('.block-tabs__link');
        this.tabsContent = this.tabs.find('.block-tabs__tab-content');
    }

    init() {
        this.tabsLinks.on('click', this.toggleTab.bind(this));
        this.toggleShadow();
    }

    toggleTab(e) {
        e.preventDefault();

        const link = $(e.delegateTarget);
        const tab = this.tabsContent.filter((i, el) => $(el).data('tab-id') === link.attr('href'));

        if (this.tabs.hasClass('disabled') || tab.hasClass('active')) {
            return;
        }

        this.tabs.addClass('switch-out disabled');
        this.tabsLinks.removeClass('active');
        this.tabsContent.addClass('switch-out');

        link.addClass('active');
        setTimeout(() => {
            this.tabsContent.removeClass('active switch-out');
            tab.addClass('active switch-in');

            setTimeout(() => {
                this.tabs.removeClass('switch-out');
                tab.removeClass('switch-in');

                AOS.refresh();
                Tables.toggleShadow();

                setTimeout(() => {
                    this.tabs.removeClass('disabled');
                }, 600);
            }, 100);
        }, 600);
    }

    toggleShadow() {
        this.tabs.each((i, el) => {
            const scrollWrapper = $(el).find('.block-tabs__list-wrapper');
            const list = scrollWrapper.children('.block-tabs__link-list');

            scrollWrapper.removeClass('has-scroll');
            if (list[0].scrollWidth > scrollWrapper.width()) {
                scrollWrapper.addClass('has-scroll');
            }
        });
    }
}

export default new Tabs();
